import { useEffect, useMemo, useContext } from "react"
import { Box } from "@mui/material"
import { externalComponent } from "../../AppRoutes"
import { api } from "../../../services/api"
import Table from "../../Table"
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { customTheme } from "../../theme/textfieldTheme"
import dayjs from "dayjs"

const url = '/novopedido/historic/'

const getColumns = () => {
    const columns = []
    columns.push({ field: 'data', headerName: 'Data', width: 180, renderCell:({value}) => dayjs(value).format('DD/MM/YYYY HH:mm') })
    columns.push({ field: 'username', headerName: 'Usuário', width: 250 })
    columns.push({ field: 'description', headerName: 'Descrição', flex: 1 })
    return columns
}

const initialize = async (id, setData, setLoader) => {
    setLoader(true)
    const res = await api.get(url + id + '/')
    if (res.status === 200) {
        setData({ rows: res.data, loaded: true })
    }
    setLoader(false)
}

const Historic = ({ id, data, setData }) => {

    const { setLoader } = useContext(externalComponent)

    useEffect(() => {
        initialize(id, setData, setLoader)
    }, [])

    const setColumns = useMemo(() => getColumns(data.rows, setData), [data.rows])

    return (
        <Box sx={{height: '100%'}}>
            {/* <ThemeProvider theme={customTheme(outerTheme)}> */}
                <Table
                    disableRowSelectionOnClick
                    paginationMode='client'
                    className='contabil-grid'
                    rows={data.rows || []}
                    columns={setColumns}
                    pagination={false}
                    toolbar
                    slots={{
                        filterComponent: true,
                        columnComponent: true
                    }}
                    density='compact'
                    rowHeight={30}
                />
            {/* </ThemeProvider> */}
        </Box>
    )
}

export default Historic